import React from 'react';
import {BaseIcon, iconDefaultProps, iconPropTypes} from './base-icon';
export const KeyboardIcon = ({...props}) => (
	<BaseIcon {...props}>
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.60001 14.9C8.26864 14.9 8.00001 15.1686 8.00001 15.5C8.00001 15.8314 8.26864 16.1 8.60001 16.1H15.4C15.7314 16.1 16 15.8314 16 15.5C16 15.1686 15.7314 14.9 15.4 14.9H8.60001Z"
				fill="#4C4C58"
			/>
			<path
				d="M9.90001 9.4C9.90001 9.89706 9.49706 10.3 9.00001 10.3C8.50295 10.3 8.10001 9.89706 8.10001 9.4C8.10001 8.90294 8.50295 8.5 9.00001 8.5C9.49706 8.5 9.90001 8.90294 9.90001 9.4Z"
				fill="#4C4C58"
			/>
			<path
				d="M12 10.3C12.4971 10.3 12.9 9.89706 12.9 9.4C12.9 8.90294 12.4971 8.5 12 8.5C11.5029 8.5 11.1 8.90294 11.1 9.4C11.1 9.89706 11.5029 10.3 12 10.3Z"
				fill="#4C4C58"
			/>
			<path
				d="M15.9 9.4C15.9 9.89706 15.4971 10.3 15 10.3C14.5029 10.3 14.1 9.89706 14.1 9.4C14.1 8.90294 14.5029 8.5 15 8.5C15.4971 8.5 15.9 8.90294 15.9 9.4Z"
				fill="#4C4C58"
			/>
			<path
				d="M18 10.3C18.4971 10.3 18.9 9.89706 18.9 9.4C18.9 8.90294 18.4971 8.5 18 8.5C17.5029 8.5 17.1 8.90294 17.1 9.4C17.1 9.89706 17.5029 10.3 18 10.3Z"
				fill="#4C4C58"
			/>
			<path
				d="M6.90001 9.4C6.90001 9.89706 6.49706 10.3 6.00001 10.3C5.50295 10.3 5.10001 9.89706 5.10001 9.4C5.10001 8.90294 5.50295 8.5 6.00001 8.5C6.49706 8.5 6.90001 8.90294 6.90001 9.4Z"
				fill="#4C4C58"
			/>
			<path
				d="M12 13.3C12.4971 13.3 12.9 12.8971 12.9 12.4C12.9 11.9029 12.4971 11.5 12 11.5C11.5029 11.5 11.1 11.9029 11.1 12.4C11.1 12.8971 11.5029 13.3 12 13.3Z"
				fill="#4C4C58"
			/>
			<path
				d="M9.90001 12.4C9.90001 12.8971 9.49706 13.3 9.00001 13.3C8.50295 13.3 8.10001 12.8971 8.10001 12.4C8.10001 11.9029 8.50295 11.5 9.00001 11.5C9.49706 11.5 9.90001 11.9029 9.90001 12.4Z"
				fill="#4C4C58"
			/>
			<path
				d="M15 13.3C15.4971 13.3 15.9 12.8971 15.9 12.4C15.9 11.9029 15.4971 11.5 15 11.5C14.5029 11.5 14.1 11.9029 14.1 12.4C14.1 12.8971 14.5029 13.3 15 13.3Z"
				fill="#4C4C58"
			/>
			<path
				d="M18.9 12.4C18.9 12.8971 18.4971 13.3 18 13.3C17.5029 13.3 17.1 12.8971 17.1 12.4C17.1 11.9029 17.5029 11.5 18 11.5C18.4971 11.5 18.9 11.9029 18.9 12.4Z"
				fill="#4C4C58"
			/>
			<path
				d="M6.00001 13.3C6.49706 13.3 6.90001 12.8971 6.90001 12.4C6.90001 11.9029 6.49706 11.5 6.00001 11.5C5.50295 11.5 5.10001 11.9029 5.10001 12.4C5.10001 12.8971 5.50295 13.3 6.00001 13.3Z"
				fill="#4C4C58"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2 8.5C2 6.84315 3.34315 5.5 5 5.5H19C20.6569 5.5 22 6.84315 22 8.5V15.5C22 17.1569 20.6569 18.5 19 18.5H5C3.34315 18.5 2 17.1569 2 15.5V8.5ZM5 6.7H19C19.9941 6.7 20.8 7.50589 20.8 8.5V15.5C20.8 16.4941 19.9941 17.3 19 17.3H5C4.00589 17.3 3.2 16.4941 3.2 15.5V8.5C3.2 7.50589 4.00589 6.7 5 6.7Z"
				fill="#4C4C58"
			/>
		</svg>
	</BaseIcon>
);

KeyboardIcon.propTypes = iconPropTypes;
KeyboardIcon.defaultProps = iconDefaultProps;
